'use strict'

import color from 'color'

/**
 * @param {String} bgColor
 * @param {String} lightColor
 * @param {String} darkColor
 * @return {String}
 * @description Returns a light or dark color depending on the comparative colour
 */
export default function contrastTextColor(
  bgColor,
  lightColor = '#ffffff',
  darkColor = '#222222',
) {
  return color(bgColor).isLight() ? darkColor : lightColor
}
